<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset"/>
        <div class="box-selected-file">
          <button class="customm" style="margin-right: 10px;" @click="export_excel">Xuất file</button>
          <input style="width: 85px" type="file" ref="myFileInput" name="importFile" class="file" @change="onImportExcel"/>
          <span class="btn-span">Nhập file</span>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onEventOptions="onEventOptions"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
        <div style="max-width:350px">
          Nếu xóa toàn bộ điểm đánh giá nếu có sẽ mất và không thể khôi phục. Bạn có chắc muốn xóa phiếu đánh giá này không?
        </div>
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning-a callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog
          style=""
          :header="label_acction"
          :visible.sync="showStatusDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <div style="width: 350px;">
            <span>{{text_status}}</span>
          </div>
          <div v-if="status!=='NEW'" style="padding-top: 4px;">
            <div v-if="status_check=='APPROVE'" style="display:flex">
              <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 50%;"/>
              <Button label="Từ chối" @click="clickCancel()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 50%;"/>
            </div>
            <div v-else style="display:flex">
              <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 50%;"/>
              <Button label="Từ chối" @click="clickCancel()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 50%;"/>
            </div>
          </div>
          <div style="padding-top: 6px;">
            <Textarea style="width:100%" v-model="note" type="text" rows="2" placeholder="Nhập ghi chú tại đây..."/>
          </div>
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showStatusDialog = false"
          icon="pi pi-times"
          class="p-button-warning-o callback-btn-o"
          />
          <Button label="Xác nhận" @click="updateStatus()" icon="pi pi-check" class="" />
          </template>
        </Dialog>
        <Dialog
          style=""
          :header="label_acction"
          :visible.sync="showStatusApproveDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <div style="width: 350px;">
            <span>{{text_status}}</span>
          </div>
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showStatusApproveDialog = false"
          icon="pi pi-times"
          class="p-button-warning-o callback-btn-o"
          />
          <Button label="Xác nhận" @click="updateStatus()" icon="pi pi-check" class="" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      areas_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      status : null,
      text_status : "",
      label_acction : "",
      evaluation_form_id : null,
      showStatusApproveDialog : false,
      note : "",
      status_check : "APPROVE",
      showStatusDialog : false,
    }
  },
  // mounted () {
    
  // },
  async created() {
    this.options["department"] = {
      offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
    };
    this.options["areas"] = {
      offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
    };
    this.initParams();
    await this.getListCompany();
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    this.modelName = this.$route.meta.model;
    // this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      console.log("this.$route.query.company_id", this.$route.query.company_id);
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
          this.company = {id: this.$route.query.company_id};
          setTimeout(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.company_id;
            this.$router.replace({ query });
          }, 100);
        }
      }
    }
    
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
        await this.getListDepartment();
        await this.getListAreas();
        // this.componentKey++;
      }
    },
    "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        // this.componentKey++;
      }
    },
    "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        // this.company = {id: this.company_id};
        // this.componentKey++;
      }
    }
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },

    async onEventOptions({event, key, data}) {
      if (key == "department") {
        this.department_obj = data;
        if (event == 'offset') {
          await this.getListDepartment();
        }
      }else if(key == "areas"){
        this.areas = data;
        if (event == 'offset') {
          await this.getListAreas();
        }
      }
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["department"] = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        };
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        this.department_obj.filters.company_id = this.company.id;
        this.department_obj.filters.active = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.department_obj.offset > 0 ) {
            this.department_obj.items.push(...res.data.data.department);
          } else{
            this.department_obj.items = res.data.data.department;
          }
          this.department_obj.total = res.data.data.total;
          this.department_obj.loading = false;
          this.options["department"] = this.department_obj;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["areas"] = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        };
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.areas_obj.loading = true;
        this.areas_obj.filters.company_id = this.company.id;
        this.areas_obj.filters.active = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.areas_obj.offset > 0 ) {
            this.areas_obj.items.push(...res.data.data.area);
          } else{
            this.areas_obj.items = res.data.data.area;
          }
          this.areas_obj.total = res.data.data.total;
          this.areas_obj.loading = false;
          this.options["areas"] = this.areas_obj;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
        await this.getListDepartment();
        await this.getListAreas();
        // this.componentKey++
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `evaluation-form/add`, title: 'Thêm'};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `evaluation-form/detail/`, title: 'Sửa'};
        }
        if (that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id', title: 'Xóa'};
        }
        if (that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('add')) {
          buttons.copy = {name: 'copy', icon: '',path: `evaluation-form/add`, key: 'id', title: 'Copy'};
        }
        if(rowData.status !== 'COMPLETE'){
          console.log("=======",that.$store.getters.controllers.evaluation_form)
          //check thêm tài khoản đăng nhập
          console.log("rowData",rowData)
          if(that.$store.getters.type == that.$constants.TYPE_USER.SUPPER_ADMIN){
            buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
          }else{
            let user_id = that.$store.getters.user;
            if(that.$store.getters.type == that.$constants.TYPE_USER.COMPANY){
              if(rowData.status == 'APPROVE'){
                if(that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('close')){
                  buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
                }
              }else{
                buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
              }
            }else{
              if(rowData.status == 'NEW' && user_id == rowData.uid_implementer){
                buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
              }else if(rowData.status == 'REVIEW' && user_id == rowData.uid_review){
                buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
              }else if(rowData.status == 'WAITTING_APPROVED' && user_id == rowData.uid_approve){
                buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
              }else if(rowData.status == 'APPROVE' && that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('close')){
                buttons.approve = {name: 'approve', icon: 'check', key: 'id', title: 'Duyệt'};
              }
            }
          }
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
      // var attributes = [];
      // for (let index = 0; index < fields.length; index++) {
      //   const element = fields[index];
      //   console.log(element.key);
      //   if (element.models !== undefined && element.models !== null) {
      //     // console.log("SDFGHJK",element)
      //     var optionsData = [];
      //     if( element['name']== "position"){
      //       // console.log("element",element)
            
      //     }
      //     // console.log("optionsData",optionsData)
      //     this.options[element.key] = optionsData;
      //   }
      //   this.componentKey++;
      // }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key]})
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company_id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path,query: { company_id: this.company_id }  })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'calculator':
          this.dialogMode = action.name
          this.$router.push({ path: action.path, query: { company_id: data.data[action.key] }  })
          break
        case 'approve':
          // console.log("data.data",data.data)
          this.status = data.data.status
          this.evaluation_form_id = data.data.id
          this.text_status = this.getTextStatus()
          this.getLabelAction()
          this.note = ''
          if(this.status == 'APPROVE'){
            this.showStatusApproveDialog = true
          }else{
            this.showStatusDialog = true
          }
          break
        case 'copy':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path,query: { page_transaction: pageTransaction.toString(), company_id: this.company_id ,id : data.data[action.key]}  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
      }
    },
    clickApprove(){
      this.status_check = "APPROVE"
    },
    clickCancel(){
      this.status_check = "CANCEL"
    },
    async updateStatus(){
      this.$commonFuction.is_loading(true);
      //gọi api cập nhật trạng thái
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var that = this
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var objects = {
          evaluation_form_id : this.evaluation_form_id,
          status : this.status,
          note : this.note,
          status_check : this.status_check,
          company_id : this.company.id,
        }
        
        await ApiRepository.post("/_api/evaluation_form/change_status", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thành công', life: 3000 })
            that.reloadPage();
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          if(err.response && err.response.data){
            if(err.response.data.message == 'DANGER_IS_NOT_EVALUATION'){
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: that.getTextalert(),
                life: 10000
              });
            }else{
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
              });
            }
          }else{
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
          }
          that.showStatusDialog = false
          that.showStatusApproveDialog = false
          that.$commonFuction.is_loading(false);
        })
      }
    },
    async reloadPage(){
      this.showStatusDialog = false
      this.showStatusApproveDialog = false
      this.$commonFuction.is_loading(false);
      this.componentKey++
    },
    getTextalert(){
      if(this.status == 'NEW'){
        return "Bạn vui lòng hoàn tất đánh giá rủi ro trước khi gửi review."
      }else if(this.status == 'REVIEW'){
        return "Bạn vui lòng hoàn tất đánh giá rủi ro trước khi gửi approve."
      }else if(this.status == 'WAITTING_APPROVED'){
        return "Bạn vui lòng hoàn tất đánh giá rủi ro trước khi approve."
      }
    },
    getTextStatus(){
      if(this.status == 'NEW'){
        return "Bạn xác nhận đã hoàn tất đánh giá và sẵn sàng để review."
      }else if(this.status == 'REVIEW'){
        return "Bạn xác nhận đã review phiếu đánh giá này. Kết quả của phiếu đánh giá này có được gửi approve không?"
      }else if(this.status == 'WAITTING_APPROVED'){
        return "Kết quả đánh giá của phiếu này có được approve không?"
      }else if(this.status == 'APPROVE'){
        return "Sau khi đóng bạn sẽ không thể thay đổi trạng thái phiếu được nữa. Bạn có chắc muốn thực hiện thao tác này không?"
      }
    },
    getLabelAction(){
      var text = ''
      if(this.status == 'NEW'){
        text = "Hoàn tất đánh giá"
      }else if(this.status == 'REVIEW'){
        text = "Hoàn tất review"
      }else if(this.status == 'WAITTING_APPROVED'){
        text = "Hoàn tất approve"
      }else if(this.status == 'APPROVE'){
        text = "Đóng phiếu đánh giá"
      }
      this.label_acction = text
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/evaluation_form/delete", {id: that.deleteId,company_id: that.company.id}, {headers}).then(function (response) {
          console.log("response",response)
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.componentKey += 1;
          }
        }).catch((err) => {
          if (err.response.data && err.response.data.message === 'NO_DELETE_BY_STATUS') {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: "Phiếu tồn tại trạng thái không thể xóa",
              life: 10000
            });
            that.$commonFuction.is_loading(false);
          }else{
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: "Phiếu tồn tại trạng thái không thể xóa",
              life: 3000
            })
            that.$commonFuction.is_loading(false);
          }
        })
      }
    },
    async export_excel(){
      this.$commonFuction.is_loading(true);
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        if(!that.company.id){
          alert("Vui lòng chọn công ty")
          this.$commonFuction.is_loading(false);
          return;
        }
        await ApiRepository.post("/_api/excel/export-eval", {company_id: that.company.id}, {headers}).then(function (response) {
          var linkExcel = response.data.data.linkExcel;
          if (linkExcel){//!this.$commonFuction.isEmptyObject(
            var link = document.createElement('a');
            link.href = linkExcel;
            link.download = linkExcel.replace(/.*\//, '');//lấy basename
            link.click()
            URL.revokeObjectURL(link.href)
            //link.dispatchEvent(new MouseEvent('click'));
          }
          that.$store.commit("setLoading", false);
          that.$toast.add({severity:'success', summary: 'Thành công', detail:'Xuất file excel thành công', life: 3000});
          that.$commonFuction.is_loading(false);
        }).catch((error) => {
          console.error('ERROR: ', error)
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          })
          that.$commonFuction.is_loading(false);
        })
      }
    },
    async onImportExcel(e) {
      this.$commonFuction.is_loading(true);
      // console.log(e, 'Import excel')
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        // const headers = {
        //   "Authorization": "Bearer "+token,
        // };
        var that = this;
        if(!that.company.id){
          alert("Vui lòng chọn công ty")
          this.$commonFuction.is_loading(false);
          return;
        }
        let files = e.target.files || e.dataTransfer.files
        let life = 5000;
        if (!files.length) return
        if (files[0].name.split('.').pop() !== 'xlsx' && files[0].name.split('.').pop() !== 'XLSX' && files[0].name.split('.').pop() !== 'xls' && files[0].name.split('.').pop() !== 'XLS') {
          this.$commonFuction.is_loading(false);
          this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng nhập file có định dạng xlsx', life: life })
          return
        }

        var formData = new FormData()
        formData.append('file', files[0]);
        
        var headerUpload = {
            headers: {
              'Content-Type': 'multipart/form-data',
              "Authorization": "Bearer " + token,
            }
        };
        await ApiRepository.post('/_api/common/check-import-eval', formData, headerUpload).then(async(response)=> {
          if(response.data.data){
            var datarequest ={
              url_file: response.data.data.url_file,
              company_id:that.company.id
            };
            // console.log("datarequest",datarequest)
            var headerUpload1 = {
              headers: {
                "Authorization": "Bearer " + token,
              }
            };
            await ApiRepository.post('/_api/common/import-eval', datarequest, headerUpload1).then(function (res) {
              console.log("resresresresresres:",res);
              that.$refs.myFileInput.value = '';
              if(res.status == 200){
                that.redirectEdit();
              }
              
              // this.$commonFuction.is_loading(false);
            })
          }
        }).catch((error)=>{
          console.log("err",error.response)
          that.$refs.myFileInput.value = '';
          var message = error.response.data.message;
          that.$commonFuction.is_loading(false);
          that.$toast.add({ severity: 'error', summary: 'Lỗi', detail: message , life: 60000 })
        })
      }
    },
    async redirectEdit() {
      var that = this;
      that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
      await this.sleep(1000)
      that.$commonFuction.is_loading(false);
      this.componentKey++;
      // window.location.reload();
    },
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-a .p-button-label{
  color: #ffffff;
}
.p-button-warning-a .pi-times{
  color: #ffffff;
}
.p-button-warning-o .p-button-label{
  color: #333333;
}
.p-button-warning-o .pi-times{
  color: #333333;
}
.callback-btn-o {
  border-color: #00000029 !important;
  background-color: #00000029 !important;
}
.box-selected-file {
  
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
}
.customm {
  padding: 7px 15px;
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF;
  border-radius: 3px;
  font-size: 0.87rem;
  color: #ffffff;
  height: 30px;
}
</style>